import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import { useHomeGlobalMarketsContent } from '../../../../hooks/useHomeGlobalMarketsContent';
import './GlobalMarkets.css';

const GlobalMarkets = () => {
  const { content, isLoading } = useHomeGlobalMarketsContent();

  if (isLoading || !content) {
    return null;
  }

  const { eyebrow, title, lead, markets } = content;
  const titleLines = title.split('\n').filter(Boolean);

  return (
    <section className="global-markets">
      <div className="global-markets__inner">
        <Reveal className="global-markets__header">
          <p className="global-markets__eyebrow">{eyebrow}</p>
          <div className="global-markets__header-grid">
            <h2 className="global-markets__title">
              {titleLines.map((line, index) => (
                <span key={line}>
                  {line}
                  {index < titleLines.length - 1 ? <br /> : null}
                </span>
              ))}
            </h2>
            <p className="global-markets__lead">{lead}</p>
          </div>
        </Reveal>

        <div className="global-markets__cards">
          {markets.map(({ name, items, icon, to }, index) => (
            <Reveal key={name} delay={index * 80}>
              <Link to={to} className="global-markets__card">
                <div className="global-markets__card-head">
                  <img
                    className="global-markets__card-icon"
                    src={icon}
                    alt=""
                    aria-hidden="true"
                  />
                  <h3 className="global-markets__card-name">{name}</h3>
                </div>
                <p className="global-markets__card-items">{items}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GlobalMarkets;
